// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","inner":"Footer_inner__fhIqU","top":"Footer_top__NUpKH"};